/*
	Import MDS based tokens.
	- This allows users to override root level properties
 */
import "@mds/designtokens";
import '@mds/media/bundled/mds-icon-fontfaces.js';
import './core.polyfills.js';

import { coreCSS } from './core.styles.js';
const styles = [coreCSS];

/**
 * Convert a 'css' file to a proper CSSStyleSheet.
 * @param css
 * @returns {CSSStyleSheet}
 * @constructor
 */
function CSSString2CSSStyleSheet ( css ) {
	const style = document.createElement ( 'style' );
	style.innerText = css;
	document.head.appendChild ( style );
	const {sheet} = style;
	document.head.removeChild ( style );
	return sheet;
}

export { CSSString2CSSStyleSheet, styles };